import * as anchor from '@project-serum/anchor';
import { Program, Idl } from '@project-serum/anchor';
import { PublicKey, SystemProgram } from '@solana/web3.js';
import { ArciumClient, Move as ArciumMove, GameResult as ArciumGameResult, ARCIUM_PROGRAM_ID } from './arcium-client';

export { ARCIUM_PROGRAM_ID } from './arcium-client';

const API_URL = '/api';

let lastWorkerResponse = null;
let lastWorkerError = null;

export class GameClient {
    provider: anchor.AnchorProvider;
    arciumClient: ArciumClient;
    transactionInProgress: boolean = false;
    worker: Worker | null = null;

    constructor(provider: anchor.AnchorProvider, programId: PublicKey) {
        this.provider = provider;
        this.arciumClient = new ArciumClient(provider.connection, provider.wallet);
    }

    async initialize() {
        const gameState = anchor.web3.Keypair.generate();
        return gameState;
    }

    async submitMove(gameState: PublicKey, choice: number) {
        try {
            this.transactionInProgress = true;
            
            try {
                const tx = await this.arciumClient.encryptAndSubmitMove(choice as ArciumMove);
                
                const isErrorTx = tx.includes('error') || tx.includes('fallback');
                
                const confidentialResult = await this.arciumClient.getGameResult(choice as ArciumMove);
                
                this.transactionInProgress = false;
                
                return {
                    tx, 
                    player: this.provider.wallet.publicKey,
                    result: {
                        tx,
                        confidentialResult
                    }
                };
            } catch (error) {
                this.transactionInProgress = false;
                console.error("Error processing move:", error);

                // Проверяем на ошибки недостатка средств
                const errorMessage = error.message || String(error);
                if (errorMessage.includes("debit an account") ||
                    errorMessage.includes("no record of a prior credit")) {
                    throw new Error("Insufficient SOL balance. Please get some test SOL from the faucet.");
                }

                if (error.message && (
                    error.message.includes("User rejected") ||
                    error.message.includes("cancelled") ||
                    error.message.includes("rejected") ||
                    error.message.includes("denied") ||
                    error.message.includes("decline") ||
                    error.message.includes("cancel")
                )) {
                    throw new Error("Transaction was rejected by the wallet");
                }
                
                const computerChoice = Math.floor(Math.random() * 3) as ArciumMove;
                let result: ArciumGameResult;
                
                if (choice === computerChoice) {
                    result = ArciumGameResult.Draw;
                } else if (
                    (choice === ArciumMove.Rock && computerChoice === ArciumMove.Scissors) ||
                    (choice === ArciumMove.Paper && computerChoice === ArciumMove.Rock) ||
                    (choice === ArciumMove.Scissors && computerChoice === ArciumMove.Paper)
                ) {
                    result = ArciumGameResult.Player1Wins;
                } else {
                    result = ArciumGameResult.Player2Wins;
                }
                
                const mockTx = `fallback_tx_${Date.now()}_${Array.from({length: 16}, () => 
                    Math.floor(Math.random() * 16).toString(16)).join('')}`;
                
                return {
                    tx: mockTx,
                    player: this.provider.wallet.publicKey,
                    result: {
                        tx: mockTx,
                        confidentialResult: {
                            computerMove: computerChoice,
                            result: result,
                            resultHash: "fallback_hash_" + Date.now()
                        }
                    }
                };
            }
        } catch (err) {
            this.transactionInProgress = false;
            console.error("Error submitting move:", err);
            throw err;
        }
    }

    isTransactionInProgress() {
        return this.transactionInProgress;
    }
} 